<template>
  <div class="match-dynamic-page page" v-loading.fullscreen.lock="loading">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate w">
        <div class="label">当前位置：</div>
        <breadcrumb />
      </section>
      <section class="content w">
        <div class="c-left">
          <h1 class="article-title">{{ dynamicInfo.articleName || "" }}</h1>
          <div class="article-author">
            <span>时间：{{dynamicInfo.releaseTime}}&nbsp;&nbsp;&nbsp;</span>
            <span v-if="dynamicInfo.department">来源：{{ dynamicInfo.department }}</span>
          </div>
          <div class="article-content" v-html="dynamicInfo.articleContent"></div>
        </div>

        <div class="c-right">
          <div class="recommend">
            <div class="listBlock" v-if="reNewsList.length">
              <div class="list-header">
                <div class="list-title">推荐阅读</div>
              </div>
              <div class="list-content">
                <div class="list-item" v-for="(item, index) in reNewsList" :key="index" @click="toReDetail(item)">
                  <div class="item-title">
                    {{ item.articleName }}
                  </div>
                </div>
              </div>
            </div>
            <div class="listBlock">
              <div class="code-content">
                <img class="img" :src="$globalHeader.fileUrl+'/static/xmdch/yx/qrcode.png'" alt="" />
                <p class="code-text">
                  <strong>厦门市大学生创业促进会公众号</strong>
                </p>
                <img class="img" :src="$globalHeader.fileUrl+'/static/xmdch/yx/weixin_zixun.jpg'" alt="" />
                <p class="code-text">
                  <strong>厦门市大学生创业促进会咨询微信</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Breadcrumb from "@/components/common/breadcrumb";
import { getArticleById, getReArticlePage } from "@/api/home/home.js"

export default {
  name: "DynamicDetail",
  components: { pageTop, Header, Footer, Breadcrumb },

  data() {
    return {
      dynamicInfo: {
        releaseTime: null,
        articleName: "",
        articleContent: "",
      },
      loading: false,
      categoryId: '',
      reNewsList: [],
    };
  },
  methods: {
    getArticleData(id) {
      if (!id || id == 'null') return
      getArticleById(id).then((res) => {
        if (!res.data) return;
        this.dynamicInfo = res.data

      })
    },
    getReArticleList(categoryId) {
      if (!categoryId || categoryId == 'null') return
      let params = {
        categoryCode: categoryId,
        page: 1,
        limit: 10,
      };

      getReArticlePage(params).then((res) => {
        if (!res.data) return;
        this.reNewsList = res.data.list

      })
    },
    toReDetail(item) {
      this.$router.push({
        path: "/newsList/newsDetail/" + item.articleId + '/' + this.categoryId,
      });
    },
  },
  watch: {
    '$route.params.id'(newValue) {
      this.getArticleData(newValue);
    },
    '$route.params.categoryId'(newValue) {
      console.log("categoryId-------", newValue);
      this.categoryId = newValue
      this.getReArticleList(newValue);
    }
  },
  created() {
    let id = this.$route.params?.id;
    this.categoryId = this.$route.params?.categoryId;
    this.getArticleData(id);
    this.getReArticleList(this.categoryId);
  },
};
</script>

<style lang="scss" scoped>
.match-dynamic-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #fff;

    .breadcrumb-plate {
      display: flex;
      align-items: center;
      padding: 16px 0;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .content {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .c-left {
        flex: 1;
        margin-right: 15px;
        background-color: #fff;
        padding: 60px 30px;
        box-shadow: 0px 2px 2px #edeef0;
        min-height: 500px;
        .article-title {
          margin: 0;
          text-align: center;
          font-weight: 700;
          font-style: normal;
          font-size: 28px;
          color: #000000;
          line-height: 1.35;
        }

        .article-author {
          color: #666666;
          margin: 30px 0;
          border-bottom: 1px dashed #ededed;
          padding-bottom: 10px;
          overflow: hidden;
          clear: both;
          font-size: 14px;
        }

        .article-content {
          font-size: 17px !important;
          line-height: 2 !important;
          min-height: 640px;
        }
      }

      .c-right {
        flex-shrink: 0;
        width: 320px;

        .recommend {
          margin-bottom: 15px;
          background-color: #fff;
        }
        .listBlock {
          padding: 20px;
          display: flex;
          flex-direction: column;

          .list-header {
            display: flex;
            font-size: 18px;
            font-weight: bold;
            padding: 10px 0;
            border-bottom: 1px dashed #cccccc;
            color: #666;
            .list-title {
              color: #005495;
              padding-right: 20px;
              position: relative;
            }
            .list-title::after {
              content: "";
              position: absolute;
              top: 20%; /* 让竖线居中 */
              bottom: 20%;
              height: 60%;
              right: -5px; /* 调整竖线位置 */
              width: 1px;
              background-color: #b3b3b3;
            }
          }
          .list-header:hover {
            color: #087cd6;
            cursor: pointer;
          }
          .code-content {
            text-align: center;
            padding: 10px 0;
            border-bottom: 1px dashed #cccccc;
            .img {
              height: 133px;
              width: 133px;
            }
            .code-text {
              padding: 10px 0;
            }
          }
          .list-content {
            padding: 10px 0;
            border-bottom: 1px dashed #cccccc;
          }
          .list-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 6px 0;
            .item-title {
              flex: 1;
              display: -webkit-box;
              word-break: break-all;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 1;
            }
            .item-title:hover {
              color: #087cd6;
              cursor: pointer;
            }
            .item-time {
              margin-left: 20px;
              color: #999;
            }
          }
          .list-item::before {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: black;
            margin-right: 8px;
          }
        }
      }
    }
  }
}
</style>
